import classNames from 'classnames';
import React, { MouseEventHandler, ReactElement, RefObject, useContext, useEffect, useRef } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import { DOT_PAGINATION_VARIANTS } from './DOT_PAGINATION_VARIANTS';
import { DotBase } from './DotBase';
import { DotPaginationContext, IDotPaginationContext } from './DotPaginationContext';

type IDotProps = IQATestableProps & IStyleableProps & {
    isCurrent: boolean;
    index: number;
    'aria-label': string;
    onClick?: MouseEventHandler;
    onMouseDown?: MouseEventHandler;
};

export function Dot (props: IDotProps): ReactElement {
    const {
        isCurrent,
        index,
        onClick,
        onMouseDown,
        'data-testid': dataTestId,
        'aria-label': ariaLabel,
        className = '',
    }: IDotProps = props;

    const { addDotRef, variant }: IDotPaginationContext = useContext<IDotPaginationContext>(DotPaginationContext);
    const dotRef: RefObject<HTMLButtonElement> = useRef<HTMLButtonElement>(null);

    useEffect((): void => {
        addDotRef(dotRef);
    }, [dotRef]);

    const dotClassNames: string = classNames({
        'h-1 w-1': true,
        'bg-yellow-500': isCurrent,
        'bg-white-500 hover:bg-gray-200': !isCurrent && variant === DOT_PAGINATION_VARIANTS.LIGHT,
        'bg-gray-500 hover:bg-gray-700': !isCurrent && variant === DOT_PAGINATION_VARIANTS.DARK,
    });

    let ariaCurrent: 'page' | undefined = undefined;

    if (isCurrent) {
        ariaCurrent = 'page';
    }

    return (
        <DotBase
            ref={dotRef}
            index={index}
            aria-label={ariaLabel}
            aria-current={ariaCurrent}
            onClick={onClick}
            onMouseDown={onMouseDown}
            data-testid={dataTestId}
            className={dotClassNames + ' ' + className}
        />
    );
}
